<template>
  <div :style="`min-height:${clientHeight}px`">
    <div class="service" ref="serviceContainer" v-if="serviceDetailStatus">
      <div class="bannerBox">
        <template >
          <banner :swiperSlides="swiperSlides" :status="`service`"></banner>
        </template>
        <div v-if="false" class="serviceBanner">
          <div class="bannerContent">
            <h1>师生服务大厅</h1>
            <div class="searchContainer">
              <input @blur="resetServiceList" @keydown.13="initServiceList" v-model="searchText"
                     :placeholder="`搜索服务...`"
                     type="text">
              <button @click="resetServiceList"><i class="iconfont icon-sousuo"></i></button>
            </div>
          </div>
          <img src="../assets/banner/service_banner.jpg" alt="">
        </div>
        <div class="banner-menu">
          <div @click="toggleTabId(item.dictValue)" v-for="(item,index) in tabsList">
            <span :class="{'on':currentTabId===item.dictValue}">{{item.dictLabel}}</span>
            <div v-if="(index + 1) !== tabsList.length" class="line"></div>
          </div>
        </div>
      </div>

      <div v-show="false" class="filterArea">
        <div class="filterAll">
          <ul class="filterMenuList">
            <li v-for="item in filterMenuList" :class="[{'on':currSelectFilterMenu===item.value},item.style]"
                @click="changeFilterMenuSelect(item)">{{item.name}}
            </li>
          </ul>
          <ul v-if="currSelectFilterMenu===1" :class="showAllFilterOptions?'':'fold'" class="sortList dept">
            <li @click="filterAction(item)" :class="{'on':item.deptId===currSelectFilterValue}"
                v-for="item in filterDeptList">
              <div class="avatar">
                <img :src="item.icon" alt="">
              </div>
              <h2 :title="item.deptName">{{item.deptName}}</h2>
              <div class="info">
                <p>{{item.serverNum}}项服务</p>
                <p>{{item.onlineNum}}项在线办理</p>
              </div>
            </li>
            <li class="clearfix"></li>
          </ul>

          <ul v-if="currSelectFilterMenu===2" :class="showAllFilterOptions?'':'fold'" class="sortList theme">
            <li @click="filterAction(item)" :class="{'on':item.dictLabel===currSelectFilterValue}"
                v-for="item in filterThemeList">
              <div class="avatar">
                <img :src="item.icon" alt="">
              </div>
              <h2 :title="item.dictLabel">{{item.dictLabel}}</h2>
              <div class="info">
                <p>{{item.serverNum}}项服务</p>
                <p>{{item.onlineNum}}项在线办理</p>
              </div>
            </li>

            <li class="clearfix"></li>
          </ul>
          <div v-if="showOptionList.length>12" @click="showAllAction" class="loadMore">
            {{showAllFilterOptions ? '收起更多' : '加载更多'}} <i class="iconfont icon-xiala"></i>
          </div>
        </div>
      </div>

      <div  class="screenBox">
        <div class="screen">
          <div class="screen-one">
            <div class="screen-one-left">
              <div class="Input">
                <input @keypress.13="initServiceList" @change="initServiceList" @blur="initServiceList"
                       v-model="searchText" type="text" placeholder="请输入服务进行搜索...">
                <div class="search" @click="initServiceList">
                  <i class="iconfont icon-sousuo"></i>
                </div>
              </div>
              <div class="collection" @click="toggleTabId('COLL')">
                <i :class="{'on':currentTabId==='COLL'}" class="icon-font bcsxushoucang"></i>
                <span :class="{'on':currentTabId==='COLL'}">我的收藏</span>
              </div>
            </div>
            <div class="screen-one-right">
              <state-ball @stateChange="selectState" :count="stateBallData" ref="stateBall"></state-ball>
            </div>
          </div>
          <div class="categoryContainer">
            <div class="category">
              <div class="title">主管单位：</div>
              <ul class="catelist deptList" @mouseleave.stop="setDeptDropListHide">
                <li :class="{'on':item.deptId===selectDept || item.show}" @mouseover="setDeptDropListShow(item)"
                    @click="changeCurrDept(item)"
                    v-for="item in deptList"><span>{{item.deptName}} <i
                v-if="getOneDeptListSon(item.deptId).length"
                :class="{'rotate':isDeptListShow && item.deptId===currDept}" class="iconfont icon-youjiantou"></i><transition
                name="tagAnim"><i
                style="font-style:normal;display: inline-block" v-if="item.show">{{item.show}} <i
                @click="removeDeptTag(item)"
                class="iconfont icon-cha"></i></i></transition></span>
                </li>
                <transition name="deptDropmenu">
                  <div v-if="getSonDeptList.length && isDeptListShow" class="dropdown">
                    <ul>
                      <li @click="selectDeptAction(item)" v-for="item in getSonDeptList">{{item.orgname}}</li>
                    </ul>
                  </div>
                </transition>
              </ul>
            </div>
            <div class="categoryContainer">
              <div class="category">
                <div class="title">服务类别：</div>
                <ul class="catelist">
                  <li :class="{'on':item.dictValue===currentCateId}" @click="categoryChange(item.dictValue)"
                      v-for="item in categoryList"><span>{{item.dictLabel}}</span></li>
                </ul>
              </div>
            </div>
            <div class="category" style="border-bottom: none">
              <div class="title">微服务类型：</div>
              <ul class="catelist deptList" @mouseleave="setProcessDropListHide">
                <li :class="{'on':item.dictValue===currType}" @mouseover="setProcessDropListShow(item)"
                    @click="toggleType(item.dictValue)"
                    v-for="item in typeList"><span>{{item.dictLabel}} <i
                v-if="item.dictValue==='1'"
                :class="{'rotate':isProcessListShow && currTypeDictId==='1'}" class="iconfont icon-youjiantou"></i><transition
                name="tagAnim"><i
                style="font-style:normal;display: inline-block"
                v-if="currLineName && item.dictValue==='1' && currType==='1'">{{currLineName}} <i
                @click="removeLineTag(item)"
                class="iconfont icon-cha"></i></i></transition></span>
                </li>
                <transition name="deptDropmenu">
                  <div v-if="isProcessListShow && currTypeDictId==='1'" class="dropdown">
                    <ul>
                      <li @click="toggleLine(item.dictValue,item.dictLabel)" v-for="item in lineList">
                        {{item.dictLabel}}
                      </li>
                    </ul>
                  </div>
                </transition>
              </ul>
              <ul v-if="false" class="catelist">
                <li :class="{'on':item.dictId===currType}" @click="toggleType(item.dictId)"
                    v-for="item in typeList"><span>{{item.dictName}}</span></li>
              </ul>
              <ul v-if="false" class="catelist right">
                <li :class="{'on':item.dictId===currLine}" @click="toggleLine(item.dictId,item.dictName)"
                    v-for="item in lineList"><span>{{item.dictName}}</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="main" id="main">
        <div v-if="scaleList.length" ref="ruler" class="ruler">
          <div :style="scaleOffsetStyle" class="scale">{{currSelectScale}}
            <span class="trangle"></span>
            <span class="ellipse"></span>
          </div>
          <ul ref="scalelist" class="scalelist">
            <li :category="item" @click="selectScale($event,item)" v-for="item in scaleList">{{item}}</li>
          </ul>
          <p v-if="serviceList.length" class="queryCount">查询到<span>{{getServiceCount}}</span>项服务</p>
        </div>
        <div v-if="isInLoadingProgress" class="loading">Loading...</div>
        <h3 class="nodata" ref="nodata" v-show="!scaleList.length"></h3>
        <ul @scroll="scrollServiceBlockList" ref="serviceBlockList" class="blocklist">
          <li :category="block.character" v-for="(block,index) in serviceList" class="block">
            <h2>{{block.character}}</h2>
            <ul class="servicelist">
              <li @click="toServiceDetail(serviceItem,$event)" v-for="(serviceItem, index) in block.appList"
                  :style="(index + 1) % 5 === 0 ? 'margin-right:0px':''">
                <img class="serviceType" :src="getServiceTypeDesc(serviceItem)" alt="">
<!--                <img v-if="serviceItem.accessByVpn === '是'" class="vpn" src="../assets/images/shang/vpnTwo.png" alt="">-->
                <div class="img-container">
                  <div>
                    <img :src="serviceItem.icon" alt="">
                  </div>
                </div>
                <div class="info-container">
                  <h3>{{serviceItem.name}}</h3>
                  <div class="star-container">
                    <rating :score="serviceItem.score?serviceItem.score:3.5"></rating>
                  </div>
                  <div>
                    <p>{{serviceItem.collectionNum}}人收藏</p>
                    <img v-if="serviceItem.accessByVpn === '是'"  class="vpn" src="../assets/images/shang/vpnOne.png" alt="">
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="detailBox" style="padding-top: 80px" v-if="!serviceDetailStatus">
      <serviceDetail :detailData="serviceDetailData" @closeServiceDetail="closeServiceDetail"></serviceDetail>
    </div>
    <div class="rightBar" v-if="false">
      <ul class="menuList">
        <li :class="{'on':currentTabId==='COLL'}" @click="toggleTabId('COLL')">
          <span><i class="iconfont icon-bianzubeifen16"></i></span>
          <p>我的收藏</p>
        </li>
        <li @click="selectState({id:item.field})" :class="{'on':item.field===filterStateField}"
            v-for="item in stateList">
          <span><i class="iconfont" :class="item.icon"></i></span>
          <p>{{item.name}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import rating from "components/globalComp/rating"
  import stateBall from "components/service/stateBall"
  import banner from "components/public/banner"
  import serviceDetail from "components/service/serviceDetail"
  //axios
  import axios from 'axios'
  import apiConfig from 'common/js/api_config'
  //vuex
  import {mapGetters, mapState, mapActions} from 'vuex'

  //通信总线
  import Bus from 'common/js/bus.js';
  //深拷贝
  import {deepClone} from "common/js/deepClone";
  import filter from "./mixin/filter";
  import serviceDetailMixin from "./mixin/serviceDetail";


  export default {
    mixins: [filter, serviceDetailMixin],
    data() {
      return {
        clientHeight: 0,
        serviceDetailStatus: true,
        swiperSlides: [],
        //当前选择的角色
        currentRole: 3,
        //搜索的文字
        searchText: null,
        //当前选项卡ID(目标对象)
        currentTabId: 111,
        tabsList: [],
        //当前分类ID
        currentCateId: 0,
        categoryList: [],
        //当前类别
        currType: null,
        typeList: [],
        //当前使用方案
        currLine: null,
        lineList: [],
        scaleList: [],
        blockInfo: [],
        currSelectScale: "",
        scaleOffsetVal: 0,
        serviceList: [],
        isCopyedServiceList: false,
        deepCopyServiceList: [],
        //展示高级筛选项
        isShowAdvanceFilter: false,
        //部门列表
        deptList: [],
        selectDept: 0,
        currDept: 0,
        //流程列表
        currTypeDictId: null,
        isProcessListShow: false,
        currLineName: null,
        //部门下拉菜单
        isDeptListShow: false,
        //根据状态筛选ids
        stateFilterIds: null,
        //小球状态所有数据
        ballStateDetail: [],
        //状态小球统计数据
        stateBallData: {
          finishNum: 0,
          myApplyNum: 0,
          runingNum: 0
        },
        //当前筛选模式 1 状态筛选模式 0 普通筛选模式
        currentFilterMode: 0,
        //是否在请求过程中
        isInLoadingProgress: false,
        //tab选项卡图标
        tabListIcon: ['icon-shishengguanli', 'icon-xuesheng', 'icon-jiaoshijianhua', 'icon-schoolFriend1', 'icon-duorenyonghu-', 'icon-shoucang'],

      }
    },
    methods: {
      ...mapActions(['openServiceDetail']),
      backChange() {
        if (this.serviceDetailStatus) {
          this.$router.go(-1)
        } else {
          this.serviceDetailStatus = true
        }
      },
      _initRoleSelect() {
        if (this.$store.getters.getUserLoginStatus) {
          console.log(this.userInfo)
          let userRole = parseInt(this.userInfo.userType)
          switch (userRole) {
            case 1:
              this.currentRole = 'T'
              break;
            case 2:
              this.currentRole = 'S'
              break;
            case 3:
              this.currentRole = 'G'
              break;
            default:
              console.log('角色数据异常:' + userRole)
          }
        } else {
          this.currentRole = 'G'
        }
      },
      //修改角色
      changeCurrRole(item) {
        this.currentRole = item.dictId;
      },
      // 轮播
      async initCarousel() {
        let carouselData = await axios.post(apiConfig.REQUEST_URL + '/shall/f_getRotationChart2');
        carouselData.data.data.forEach((item) => {
          this.swiperSlides.push(item.path);
        })
      },
      getDOMX(dom) {
        return dom.getBoundingClientRect().x || dom.getBoundingClientRect().left;
      },
      //切换分类
      categoryChange(id) {
        this.currentCateId = id;
        console.log("currentCateId")
        console.log(this.currentCateId)
        this.initServiceList()
      },
      //切换状态
      selectState(id) {
        id = id.id;
        this.filterStateField = id
        if (this.$refs.stateBall.currentSelState === id) {
          this.$refs.stateBall.currentSelState = 0;
          this.stateFilterIds = null
          this.filterStateField = null
          this.initServiceList(1)
          return;
        }
        this.$refs.stateBall.currentSelState = id;
        //id:字段名
        // this.filterServiceListByState(id)
        this.initServiceList(1)
      },
      selectScale(ev, tag) {
        setTimeout(() => {
          this.currSelectScale = tag;
          this.scaleOffsetVal = this.getDOMX(ev.srcElement) - this.getDOMX(scaleLiArr[0]);
        }, 100);
        let scaleLiArr = this.$refs.scalelist.getElementsByTagName("li");
        this.blockInfo.forEach((item, index) => {
          if (item.category === tag) {
            //this.scrollToTargetPos(item.current)
            this.$refs.serviceBlockList.scrollTop = item.current
          }
        });
        let htmlObj = document.getElementsByTagName("html")[0];
        htmlObj.scrollTop = 210;
      },
      vernierToScale(tag) {
        let scaleLiArr = this.$refs.scalelist.getElementsByTagName("li");
        let targetScaleDom;
        for (let i = 0; i < scaleLiArr.length; i++) {
          if (scaleLiArr[i].getAttribute("category") === tag) {
            targetScaleDom = scaleLiArr[i];
          }
        }
        if (!targetScaleDom) {
          return false;
        }
        this.scaleOffsetVal = this.getDOMX(targetScaleDom) - this.getDOMX(scaleLiArr[0]);
        this.currSelectScale = tag;
      },
      scrollServiceBlockList(ev) {
        let currScrollTop = ev.srcElement.scrollTop;
        let nextScrollTop;
        for (var i = 0; i < this.blockInfo.length; i++) {
          if (this.blockInfo[i + 1]) {
            nextScrollTop = this.blockInfo[i + 1].current
          } else {
            nextScrollTop = Infinity;
          }

          if (currScrollTop >= this.blockInfo[i].current && currScrollTop < nextScrollTop) {
            this.vernierToScale(this.blockInfo[i].category)
          }
        }
      },
      scrollToTargetPos(targetVal) {
        let currentScrollTop = this.$refs.serviceBlockList.scrollTop;
        let tempVal = currentScrollTop;
        let direction = targetVal > tempVal;
        let offsetDistance = direction ? 100 : -100;
        let animTimer = setInterval(() => {
          tempVal += offsetDistance;
          this.$refs.serviceBlockList.scrollTop = tempVal;
          if (!direction && (tempVal < targetVal - offsetDistance || tempVal >= this.$refs.serviceBlockList.scrollHeight)) {
            clearInterval(animTimer)
          }
          if (direction && (tempVal > targetVal || tempVal >= this.$refs.serviceBlockList.scrollHeight)) {
            clearInterval(animTimer)
          }
        }, 50);
      },
      //切换tab
      toggleTabId(tabId) {
        if (tabId === this.currentTabId && tabId !== 'COLL') {
          this.currentTabId = null
          this.initServiceList();
          return
        }
        if (tabId === 'COLL' && this.currentTabId === 'COLL') {
          this.currentTabId = this.getUserTypeInDict(this.userInfo.userType)
        } else {
          this.currentTabId = tabId;
          if (tabId === '') {
            this.searchText = null
            this.selectDept = 0
            this.currentCateId = ''
            this.currType = ''
            this.currLine = null
          }
        }
        if (this.currSelectFilterMenu === 1) {
          this.fetchFilterDeptList()
        } else if (this.currSelectFilterMenu === 2) {
          this.fetchFilterThemeList()
        } else {

        }
        this.initServiceList();

      },
      //切换type
      toggleType(typeId) {
        this.currLine = ''
        this.currType = typeId;
        this.initServiceList();
      },
      //切换line
      toggleLine(lineId, lineName) {
        this.currType = '1';
        this.currLine = lineId;
        this.currLineName = lineName;
        this.initServiceList();
      },


      //初始化类别
      initCategory() {
        let promise = new Promise(async (resolve, reject) => {
          let categoryData = await axios.post(apiConfig.REQUEST_URL + "/shall/f_getServiceSort").catch(() => {
            reject();
          });
          resolve();
          categoryData = categoryData.data.data;
          if (!categoryData.length) {
            return;
          }
          this.categoryList = categoryData;
          this.currentCateId = categoryData[0].dictValue;
        });
        return promise;
      },
      //初始化角色
      initRole() {
        let promise = new Promise(async (resolve, reject) => {
          let roleData = await axios.post(apiConfig.REQUEST_URL + "/shall/f_getServiceTarget?type=0").catch(() => {
            reject();
          });
          resolve();
          roleData = roleData.data.data;
          if (!roleData.length) {
            return;
          }
          let data = []
          roleData.forEach(item => {
            if (item.dictValue !== 'COLL') {
              data.push(item)
            }
          })
          this.tabsList = data;
          this.currentTabId = this.getUserTypeInDict(this.userInfo.userType);
          this.fetchFilterDeptList()
          this.fetchFilterThemeList()
        });
        return promise;
      },
      //初始化类型
      initType() {
        let promise = new Promise(async (resolve, reject) => {
          let typeList = await axios.post(apiConfig.REQUEST_URL + "/shall/f_getServiceType").catch(() => {
            reject();
          });
          resolve();
          typeList = typeList.data.data;
          if (!typeList.length) {
            return;
          }
          this.typeList = typeList;
          this.currType = typeList[0].dictValue;
        });
        return promise;
      },
      //初始化方案
      initLine() {
        let promise = new Promise(async (resolve, reject) => {
          let lineList = await axios.post(apiConfig.REQUEST_URL + "/shall/f_getServiceLine").catch(() => {
            reject();
          });
          resolve();
          lineList = lineList.data.data;
          if (!lineList.length) {
            return;
          }
          this.lineList = lineList;
          this.currLine = lineList[0].dictId;
        });
        return promise;
      },
      getSort(id) {
        if (id === '') {
          return ''
        } else {
          let data = ''
          this.categoryList.forEach(item => {
            if (item.dictValue === id) {
              data = item.dictLabel
            }
          })
          return data
        }
      },
      getState(e) {
        switch (e) {
          case 0:
            return 0
          case 'runingNum':
            return 1
          case 'finishNum':
            return 2
          case 'myApplyNum':
            return 3
        }
      },
      //初始化服务列表
      async initServiceList(isFromStateBallFilter) {
        this.isInLoadingProgress = true

        if (this.$refs.stateBall) {
          if (this.$refs.stateBall.currentSelState && !isFromStateBallFilter) {
            this.$refs.stateBall.currentSelState = 0
            this.stateFilterIds = ''
            this.initServiceList()
            return
          }
        }

        let serviceListData = await axios.post(apiConfig.REQUEST_URL + "/shall/f_getServiceList?" + this.$qs.stringify({
          serSort: this.currSelectFilterMenu === 2 ? this.currSelectFilterValue : null,//类别
          serTarget: this.currentTabId,//目标对象
          state: this.getState(this.$refs.stateBall.currentSelState),//状态 0 不分 1 进行中 2 已完成 3 我发起的
          keyword: this.searchText,//搜索的关键词
          type: this.currType,
          serLine: null,
          orgid: this.currSelectFilterMenu === 1 ? this.currSelectFilterValue : null
          // ids: this.stateFilterIds
        }));
        this.isInLoadingProgress = false;
        serviceListData = serviceListData.data.data;
        this.serviceList = serviceListData;
        this.$nextTick(() => {
          this.calcServiceData()
        })
        this.$nextTick(() => {
          this._initBallState()
        })
        if (!this.serviceList.length) {
          this.$refs.nodata.innerHTML = "暂无数据"
        }

        if (!this.$refs.stateBall.currentSelState) {
          this.deepCopyServiceList = this.deepCopyServiceListAction()
          this.isCopyedServiceList = true
        }
      },

      //请求服务列表


      calcServiceData() {
        let serviceBlockList = this.$refs.serviceBlockList;
        let serviceBlockArr = serviceBlockList.getElementsByClassName("block");
        this.scaleList = [];
        for (var i = 0; i < serviceBlockArr.length; i++) {
          let categoryTag = serviceBlockArr[i].getAttribute("category");
          this.blockInfo.push({
            category: categoryTag,
            current: serviceBlockArr[i].offsetTop - serviceBlockArr[0].offsetTop
          });
          this.scaleList.push(categoryTag)
        }
        this.currSelectScale = this.scaleList[0];
      },
      initFixRuler() {
        let oRuler = this.$refs.ruler;
        if (!oRuler) {
          return
        }
        window.addEventListener("scroll", (ev) => {
          let scrollTop = ev.srcElement.scrollingElement.scrollTop;
          if (scrollTop >= 220) {
            oRuler.style.position = "fixed";
            oRuler.style.top = "50px";
          } else {
            oRuler.style.position = "relative";
            oRuler.style.top = "0";
          }
        })


      },
      toggleShowAdvanceFilter() {
        this.isShowAdvanceFilter = !this.isShowAdvanceFilter
      },
      async _initDeptInfo() {
        let deptInfo = await axios.post(apiConfig.REQUEST_URL + '/shall/f_getOrganizationList')
        if (!deptInfo.data.status) {
          return
        }
        deptInfo = deptInfo.data.data[0].children
        deptInfo.forEach((dept) => {
          dept.show = null
        })
        deptInfo.unshift({
          deptId: 0,
          deptName: "不限",
          children: [],
          show: null
        })
        this.deptList = deptInfo
      },
      //隐藏下拉菜单
      setDeptDropListHide() {
        this.isDeptListShow = false
      },
      //显示下拉菜单
      setDeptDropListShow(item) {
        this.currDept = item.id
        this.isDeptListShow = true
      },
      getOneDeptListSon(id) {
        let currDeptId = id;
        let ret = []
        this.deptList.forEach((item, index) => {
          if (item.id === currDeptId) {
            console.log(item.children)
            ret = item.children
          }
        })
        return ret
      },
      changeCurrDept(item) {
        this.deptList.forEach((item, index) => {
          item.show = null
          item.children.forEach((dept) => {
            dept.show = null
          })
        })


        this.isDeptListShow = true
        this.currDept = item.deptId
        this.selectDept = item.deptId
      },


      //隐藏下拉菜单
      setProcessDropListHide() {
        this.isProcessListShow = false
      },
      //显示下拉菜单
      setProcessDropListShow(item) {
        this.currTypeDictId = item.dictValue
        this.isProcessListShow = true
      },
      removeLineTag() {
        this.toggleLine('', '')
      },

      //筛选部门
      selectDeptAction(sonItem) {
        let currDeptId = this.currDept;
        this.deptList.forEach((item, index) => {
          if (item.id === currDeptId) {
            item.show = sonItem.orgname
            this.selectDept = sonItem.id
            this.isDeptListShow = false
            return
          }
          item.show = null
        })
      },
      //移除标签
      removeDeptTag(item) {
        item.show = null
        this.selectDept = this.currDept
        this.initServiceList()
      },

      //根据名称获取服务数据
      getServiceDataByName(serviceName, useCloneList) {
        let serviceList = useCloneList ? this.deepCopyServiceList : this.serviceList
        for (let i = 0; i < serviceList.length; i++) {
          if (!serviceList[i].appList.length) {
            continue
          }
          for (let j = 0; j < serviceList[i].appList.length; j++) {
            if (serviceList[i].appList[j].name === serviceName) {
              return serviceList[i].appList[j];
            }
          }
        }
        return null
      },


      //设置服务项小球状态
      setServiceItemBallState(serviceItem, ballState) {
        if (!serviceItem) {
          return
        }
        const KEY_LIST = ['finishNum', 'myApplyNum', 'runingNum']
        KEY_LIST.forEach((key) => {
          serviceItem[key] = ballState[key]
        })
      },

      //设置状态小球统计
      setStateBallCount(ballState) {
        console.log(ballState)
        this.stateBallData.finishNum += ballState.finishNum
        this.stateBallData.myApplyNum += ballState.myApplyNum
        this.stateBallData.runingNum += ballState.runingNum
      },
      //设置状态小球统计
      setStateBallToZero() {
        this.stateBallData.finishNum = 0
        this.stateBallData.myApplyNum = 0
        this.stateBallData.runingNum = 0
      },
      filterServiceListByState(stateField) {
        /***
         * stateField 筛选的字段
         * scoped 筛选的范围是否是当前展示的数据 1 展示数据 0 深拷贝数据
         */
        let selectService = []
        console.log(this.ballStateDetail);
        this.ballStateDetail.forEach((ballState) => {
          if (ballState[stateField]) {
            if (this.getServiceDataByName(ballState.name, 1)) {
              selectService.push(this.getServiceDataByName(ballState.name, 1).id)
            }
          }
        })
        console.log('%c筛选的服务：', 'font-size:50px;color:#00f;font-weight:bold;border:1px solid #eee')
        this.stateFilterIds = selectService.join(',') || -1
      },
      //初始化小球状态
      async _initBallState() {
        this.setStateBallToZero()
        let ballState = await axios.post(apiConfig.REQUEST_URL + '/shall/f_getServiceCount')
        ballState = ballState.data.data[0]
        this.ballStateDetail = ballState
        for (let i in this.ballStateDetail) {
          for (let y in this.stateBallData) {
            if (i === y) {
              this.stateBallData[y] = this.ballStateDetail[i]
            }
          }
        }
        // ballState.forEach((ballState) => {
        //   let serviceItem = this.getServiceDataByName(ballState.name)
        //   let originServiceItem = this.getServiceDataByName(ballState.name, 1)
        //   this.setServiceItemBallState(serviceItem, ballState)
        //   if (originServiceItem) {
        //     this.setStateBallCount(ballState)
        //   }
        // })
      },
      deepCopyServiceListAction() {
        return this.serviceList;
      },
      //进入待办详情
      /***
       *
       * @param stateNum 0 runingNum 1 finishNum -1 myApplyNum
       * @param serviceItem
       */
      toTodoDetail(stateNum, serviceItem) {
        if (!this.getUserLoginStatus) {
          this.$notify({
            group: "global",
            title: "温馨提示",
            text: "登录后才能查看自己的事项呦！"
          });
          return
        }
        this.$modal.show('todo', {
          sendState: stateNum,
          type: 2,
          data: {sysname: serviceItem.name}
        })
      },
      //初始化布局
      _initServiceListLayout() {
        this.$refs.serviceBlockList.style.height = 'calc( 100vh - 280px)'
        this.$refs.serviceBlockList.style.marginBottom = '-50px'
      },
      getUserTypeInDict(id) {
        switch (id) {
          case '1':
            //教职工
            return 'T'
          case '2':
            //学生
            return 'S'
          default:
            return 'FK'
        }
      },
      getServiceTypeDesc(serviceItem) {
        let typeId = serviceItem.type;

        switch (typeId) {
          case 0:
            return require('../assets/serviceType/app.png')
          case 1:
            switch (serviceItem.onlineSort) {
              case 'online':
                return require('../assets/serviceType/online.png')
              case 'offlineorder':
                return require('../assets/serviceType/order.png')
              case 'offline':
                return require('../assets/serviceType/form.png')
              default:
                console.log('serviceItem.onlineSort:' + serviceItem.onlineSort)
            }
          case 2:
            return require('../assets/serviceType/system.png')
          case 3:
            return require('../assets/serviceType/form.png')
          case 4:
            return require('../assets/serviceType/tool.png')
          default:
            console.log('getServiceTypeDesc参数异常', typeId)
            return 0
        }
      },
      getServiceTypeDescBack(serviceItem) {
        let typeId = serviceItem.type;

        switch (typeId) {
          case 0:
            return {title: '应用', color: '#78a066'}
          case 1:
            switch (serviceItem.onlineSort) {
              case 'online':
                return {title: '线上', color: '#155987'}
              case 'offlineorder':
                return {title: '预约', color: '#439138'}
              case 'offline':
                return {title: '指南', color: '#6b96a7'}
              default:
                console.log('serviceItem.onlineSort:' + serviceItem.onlineSort)
            }
          case 2:
            return {title: '系统', color: '#998226'}
          case 3:
            return {title: '表单', color: '#6c4b42'}
          case 4:
            return {title: '工具', color: '#4d838a'}
          default:
            console.log('getServiceTypeDesc参数异常', typeId)
            return 0
        }
      }
    },
    computed: {
      ...mapState(['userInfo']),
      scaleOffsetStyle() {
        return `transform:translateX(${this.scaleOffsetVal}px)`
      },
      getSonDeptList() {
        let currDeptId = this.currDept;
        let ret = []
        this.deptList.forEach((item, index) => {
          if (item.deptId === currDeptId) {
            ret = item.children
          }
        })
        return ret
      },
      getServiceCount() {
        let count = 0
        this.serviceList.forEach((service, index) => {
          count += service.appList.length
        })
        return count
      },

      ...mapGetters(['getUserLoginStatus'])

    },
    created() {
      //搜索
      if (this.$route.query.searchText) {
        this.searchText = this.$route.query.searchText;
      }
    },
    filters: {},
    async mounted() {
      this._initRoleSelect()
      this.initCarousel()
      //卡标尺
      this.initFixRuler();
      //初始化分类
      await this.initCategory();
      //初始化对象
      await this.initRole();
      //初始化类型
      await this.initType();
      //初始化方案
      await this.initLine();

      //初始化部门信息
      this._initDeptInfo()
      //初始化布局
      this._initServiceListLayout()
      this.typeList.forEach(item => {
        if (item.dictLabel === this.$route.query.text) {
          this.currType = item.dictValue
        }
      })
      //初始化服务列表
      this.initServiceList();
      Bus.$on('menuChange', () => {
        this.serviceDetailStatus = true
      })
      if (window.history && window.history.pushState) {
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', this.backChange, false)
      }
    },
    destroyed() {
      window.removeEventListener('popstate', this.backChange, false)
    },
    watch: {
      selectDept(newVal) {
        this.initServiceList()
      },
      '$route.query.searchText'(newVal) {
        this.searchText = newVal
        this.initServiceList()
      }
    },
    components: {rating, stateBall, banner, serviceDetail},
    name: "service"
  }
</script>

<style lang="stylus" scoped>
  @import "../common/stylus/config.styl"
  @import "../common/stylus/placeholder.styl"
  @media screen and (max-width: 1440px)
    .bannerBox
      min-height auto !important

  .service
    padding-top 80px
    height 100%

    .filterArea
      padding-top 50px
      background-color #ffffff

      .filterAll
        width 1400px
        margin auto
        position relative

        .filterMenuList
          position absolute
          left -10px
          top 0

          & > li
            width 100px
            height 40px
            line-height 40px
            color #8E94A1
            background-color #E3E7EB
            margin-bottom 10px
            border-radius 5px
            text-align center
            font-size 16px
            cursor pointer

            &.on
              background-color #006EC7
              color #ffffff

              &.theme
                background-color #009D6D


        .sortList
          padding 50px 100px 0

          &.fold
            max-height 510px
            overflow hidden

          & > li
            float left
            width 180px
            height 200px
            background-color #ffffff
            text-align center
            box-shadow 0px 2px 20px 0px rgba(28, 96, 130, 0.15)
            border-radius 8px
            margin-right 24px
            margin-bottom 32px
            position relative

            &:nth-of-type(6n)
              margin-right 0

            &.on

              &:after
                content ''
                position absolute
                left 0
                right 0
                top 0
                bottom 0
                z-index 2
                background-color rgba(0, 110, 199, 0.2)


            //h2, p
            //  color #ffffff !important

            div.avatar
              margin-top 30px

              img
                width 50px
                height 50px
                background-color #ffffff
                border-radius 10px

            h2
              color #222222
              font-size 16px
              font-weight bold
              margin-top 20px
              margin-bottom 20px
              white-space nowrap
              overflow hidden
              text-overflow ellipsis

            p
              margin-top 8px
              color #7A7E81
              font-size 14px

            &.clearfix
              width 100%
              float none
              height 0
              clear both
              margin 0

        .loadMore
          width 100%
          height 40px
          line-height 40px
          margin-bottom 0
          box-shadow none
          color #ACB5C2
          font-size 14px
          cursor pointer
          text-align center
          margin-top -20px

          i.iconfont
            font-size 12px
            display inline-block
            transform scale(0.8)


    .detailBox
      width 100%

    .bannerBox
      width 100%
      position relative

      .banner-menu
        height 60px
        background rgba(255, 255, 255, 1)
        box-shadow 0px 2px 10px 0px rgba(0, 0, 0, .1)
        border-radius 5px
        position absolute
        left 50%
        transform translateX(-50%)
        bottom -30px
        z-index 9
        padding 0 13px
        box-sizing border-box

        div
          width 170px
          height 100%
          display flex
          align-items center
          justify-content center
          font-size 16px
          color #999999
          font-weight bold
          position relative
          float left
          line-height 60px
          text-align center

          .line
            width 1px
            height 26px
            background #eeeeee
            position absolute
            right 0px
            top 50%
            transform translateY(-50%)

          span
            cursor pointer
            font-weight bold

          .on
            color themeColor

      .serviceBanner
        position relative

        .bannerContent
          position absolute
          left 0
          right 0
          top 0
          bottom 0
          height 120px
          margin auto
          text-align center

          h1
            color #FFFFFF
            font-size 30px
            margin-bottom 40px

          .searchContainer
            margin auto
            width 700px
            height 50px
            position relative
            border-radius 5px
            overflow hidden

            input
              width 100%
              height 100%
              font-size 16px
              color #666666
              padding-left 1em

            button
              width 55px
              height 100%
              background-color #006EC7
              position absolute
              right 0
              top 0
              bottom 0
              border 2px solid #ffffff
              outline none

              i.iconfont
                color #ffffff
                font-size 18px

        img
          width 100%

    .screenBox
      width 100%
      min-height 274px
      background #ffffff

      .screen
        width 1400px
        height 100%
        padding-top 61px
        margin 0 auto

        .screen-one
          width 100%
          height 30px
          margin-bottom 10px

          .screen-one-left
            width 600px
            height 100%
            float left

            .Input
              width 469px
              height 100%
              border 1px solid #e6e6e6
              border-radius 5px
              overflow hidden
              float left

              input
                width 410px
                height 100%
                padding 8px 12px
                box-sizing border-box
                font-size 12px
                color #999999
                float left

              .search
                width 54px
                height 100%
                background #0073BE
                cursor pointer
                float right
                text-align center
                line-height 27px

                .icon-sousuo
                  color #ffffff

            .collection
              height 100%
              cursor pointer
              float right
              line-height 25px

              .bcsxushoucang
                color #b7b9bb

              span
                margin-left 3px
                font-size 14px
                color #666666

              .on
                color themeColor

          .screen-one-right
            height 100%
            float right

    .main
      width 100%
      max-width 1500px
      margin auto
      position relative
      padding-top 30px

      .tab
        width 1400px
        font-size 14px
        height 100%
        line-height 50px
        padding-left 16px
        border-bottom 1px solid #f0f0f0
        background-color #ffffff
        position relative
        box-shadow 2px 1px 3px #ddd;
        margin 0 auto

        &::after
          content ""
          display block
          width 100%
          clear both

        & > .category
          box-shadow none

        & > span
          display block
          width 120px
          margin-right 8px
          text-align center
          float left
          cursor pointer
          color #696969

          i
            margin-right 4px
            color #5b80b8

          &.on
            border-bottom 2px solid #888888

        .stateBallContainer
          display inline-block
          float right
          padding-left 15px

          & >>> .status-desc
            float left
            margin-top 8px
            margin-right 20px


      .categoryContainer
        width 1400px
        position relative
        margin 0 auto

        .showMore
          background #026da5
          width 150px
          height 20px
          border 1px solid #cccccc
          border-top #eeeeee
          position absolute
          top 0
          left 0
          right 0
          margin auto
          bottom -22px
          z-index 99
          text-align center
          line-height 20px
          color #cccccc
          border-bottom-left-radius 20px
          border-bottom-right-radius 20px
          cursor pointer
          font-size 12px
          box-shadow 0 3px 5px #dddddd
          box-sizing content-box
          padding-top 5px
          border-left none
          border-right none

          &:hover
            background linear-gradient(#ffffff, #eeeeee)

      .loading
        position absolute
        left 0
        right 0
        top 195px
        bottom 0
        margin auto
        line-height 500px
        text-align center
        font-size 20px
        color #cccccc
        background-color rgba(255, 255, 255, 0.8)
        z-index 9999


  .category
    min-height 50px
    line-height 50px
    background-color #ffffff
    position relative
    border-bottom 1px solid #eeeeee

    &::after
      content ""
      display block
      width 100%
      clear both

    li.on
      display inline-block

    .title
      white-space nowrap
      font-size 14px
      color #666666
      font-weight bold
      float left
      width 80px
      text-align left

    .deptList
      margin-right 15px

      li
        span
          .iconfont
            font-size 8px
            display inline-block
            transition 300ms
            transform scale(0.8)

            &.rotate
              transform scale(0.8) rotate(90deg)

    .stateBallContainer
      display inline-block
      float right
      width 550px
      padding-left 15px

      & >>> .status-desc
        float left
        margin-top 8px

    .catelist
      display inline-block
      height 100%
      margin-left 26px
      float left

      &.right
        float right
        width 546px

      &::after
        content ""
        display block
        width 100%
        clear both

      & > .dropdown
        position absolute

        left 0
        top 90%
        border 1px solid #eeeeee
        background-color #ffffff
        width 100%
        min-height 58px
        z-index 1000
        padding 0 25px
        cursor default

        ul
          text-align right

          li
            font-size 12px
            height 24px
            line-height 24px
            color #666666
            margin 5px
            padding 0 5px
            border-radius 12px

            &:hover
              background-color #eeeeee

            &::after
              right -5px

      li
        float left
        height 100%
        padding 0 3px
        margin 0 5px
        position relative
        cursor pointer

        &:last-of-type::after
          display none

        &::after
          content ""
          position absolute
          top 0
          bottom 0
          margin auto
          display block
          right -5px
          margin-left 15px
          border-right 1px solid #ffffff
          height 14px

        i
          .iconfont
            vertical-align middle
            font-size 16px

        span
          padding 3px 10px
          border-radius 5px
          font-size 14px
          color #666666

      li.on
        span
          color #ffffff
          background-color themeColor

    &.half
      font-size 0
      width 50%
      display inline-block

  .ruler
    width 1400px
    height 36px
    background-color #ffffff
    margin 0 auto
    margin-bottom 35px
    position relative
    z-index 1

    .queryCount
      position absolute
      right 35px
      top 135%
      bottom 0
      font-size 14px
      color #666666

      & > span
        margin 0 5px
        color #548EDF

    .scale
      font-size 16px
      width 33px
      height 36px
      line-height 36px
      background-color themeColor
      position absolute
      left 28px
      z-index 9
      top 0
      text-align center
      color #ffffff
      transition 300ms

      .trangle
        position absolute
        left 0
        top 100%
        width 0
        height 0
        border-left: 16px solid transparent;
        border-right: 16px solid transparent;
        border-top: 14px solid themeColor

      .ellipse
        position absolute
        top -4px
        left 0
        width 100%
        height 12px
        border-radius 6px
        background-color themeColor

    .scalelist
      padding-left 27px

      li
        width 32px
        float left
        margin-right 8px
        text-align center
        line-height 35px
        font-size 16px
        color #cccccc
        position relative
        transition 300ms
        cursor pointer

        &:hover
          background-color #eeeeee

  .blocklist
    height 800px
    padding 0 50px
    padding-bottom 300px
    overflow-y scroll
    transition 300ms
    box-sizing border-box

    h2
      font-size 16px
      color #333333
      width 100%
      height 50px
      display flex
      align-items center

    .block
      .servicelist
        &::after
          content ""
          display block
          width 100%
          clear both

        & > li
          width 261px
          height 120px
          float left
          cursor pointer
          transition 300ms
          border-radius 8px
          border 1px solid rgba(240, 240, 240, 1)
          box-shadow 0px 2px 20px 0px rgba(28, 96, 130, 0.15)
          background #ffffff
          margin 0 21px 21px 0
          position relative

          .serviceType
            position absolute
            right -1px
            top -1px
          .vpn
            width 36px
            height 16px
          .img-container
            display table
            width 87px
            height 100%
            float left
            text-align center
            position relative

            div
              display table-cell
              vertical-align middle

              img
                width 70px
                height auto
                max-height 100px
                border-radius 50%
                float right

              span
                position absolute
                display block
                border-radius 50%
                top 20px
                right 6px

                i
                  font-size 18px
                  color #C23531
                  background-color #ffffff
                  border-radius 50%

          .info-container
            width 162px
            float right
            img
              margin-top: 10px;
              margin-left: 10px;
            h3, p
              white-space nowrap
              overflow hidden
              text-overflow ellipsis

            h3
              font-weight bolder
              padding-right 10px
              font-size 16px
              color #222222
              margin-top 25px
              margin-bottom 12px

            p
              float left
              font-size 14px
              color #999999
              letter-spacing 0
              margin-top 12px

            .star-container
              margin-top 5px
              margin-left -1px
              width 80px
              height 16px

  .rightBar
    position fixed
    right 0
    top 200px
    width 70px
    height 275px
    padding-top 10px
    background-color rgba(255, 255, 255, 0.9)
    box-shadow 0px 0px 10px 0px rgba(100, 108, 115, 0.16)

    .menuList
      & > li
        text-align center
        width 100%
        height 70px
        cursor: pointer;

        &.on
          span i.iconfont
            color #006ec7

        span
          line-height 30px

          i.iconfont
            color #A1A9BB
            font-size 16px

        p
          font-size 12px
          color #666666

        &:first-of-type
          height 60px
          margin-bottom 10px
          border-bottom 1px solid #eeeeee

  /*部门选择下拉菜单动画*/
  .deptDropmenu-enter, .deptDropmenu-leave-to
    opacity 0
    transition 500ms
    transform translate3d(0, -20px, 0)

  .deptDropmenu-enter-active, .deptDropmenu-leave-active
    transition: all 300ms ease-out;

  //部门选择小标签动画
  .deptDropmenu-enter, .deptDropmenu-leave-to
    opacity 0
    transition 500ms
    transform translate3d(0, -20px, 0)

  .deptDropmenu-enter-active, .deptDropmenu-leave-active
    transition: all 300ms ease-out;

  //部门选择小标签动画
  .tagAnim-enter, .tagAnim-leave-to
    opacity 0
    transform scaleX(0)

  .tagAnim-enter-active, .tagAnim-leave-active
    opacity 1
    transition: all 300ms ease-out;

  /*绿色版皮肤*/
  .green
    .service
      .main
        .categoryContainer
          .showMore
            background-color greenThemeValue

        .tab
          span i
            color greenThemeValue

          & >>> .status-desc > div.on
            color greenThemeValue !important

          .queryCount > span
            color greenThemeValue

        .category
          .catelist
            li.on span
              background-color greenThemeValue

        .ruler
          .scale
            background-color greenThemeValue

            .ellipse
              background-color greenThemeValue

            .trangle
              border-top-color greenThemeValue

          .scalelist
            li .scale, li .scale .ellipse
              background-color greenThemeValue

            li .scale .trangle
              border-top-color greenThemeValue
</style>



// WEBPACK FOOTER //
// src/pages/service.vue